module.exports = __webpack_public_path__ + "2e9bc207bce224d8f5c25f03e2f47816.png";